var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qms-requirement-applicability-component',{attrs:{"qms-requirement":_vm.qmsRequirement,"editable":_vm.editable,"dispatch-qms-requirement-change":_vm.dispatchQmsRequirementChange}})}
var staticRenderFns = []

export { render, staticRenderFns }